
export const TEXT = {
  CONTEXTUAL_COMMENTS_TITLE: 'Contextual comments: ',
  CONTEXTUAL_COMMENTS_BODY: 'This text box is for you to write a summary to contextualize the data you have provided for these metrics.'
}

export const NO_ANSWER_SUBMITTED = 'No answer submitted';
